module.exports = __webpack_public_path__ + "static/media/Dokhtar.cf1b229d.png";